import * as Locations from '../services/Locations'

export const removeLocation = (id) => (dispatch, getState) => {
  return Locations.remove(id)
}

export const upsertLocation = (location) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  return Locations.upsert(location, subsidiaryId)
}
